import { render } from "./ButtonBase.vue?vue&type=template&id=2016d77a&scoped=true"
import script from "./ButtonBase.vue?vue&type=script&lang=js"
export * from "./ButtonBase.vue?vue&type=script&lang=js"

import "./ButtonBase.vue?vue&type=style&index=0&id=2016d77a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2016d77a"]])

export default __exports__